import { Link } from "react-router-dom";
import { cn } from "../utils/utils";

function Footer(props: { className?: string }) {
  return (
    <footer
      className={cn("py-12 px-2 md:px-[5%] bg-slate-100", props.className)}
    >
      <hr className="w-full mb-4 border-slate-800" />
      <div className="flex flex-col md:flex-row justify-between gap-8 md:gap-4">
        <div className="w-fit flex flex-col">
          <div className="text-lg font-bold">Useful Links</div>
          <Link
            to={"https://hkfullforce.com"}
            target="_blank"
            className="text-blue-500 underline"
          >
            Hong Kong Full Force
          </Link>
        </div>
        <div className="w-fit flex flex-col">
          <h1 className="text-lg font-bold">Get in Touch</h1>
          <div className="flex flex-col text-sm">
            <div>
              Unit 411, 4/F, Hope Sea Industrial Centre, 26 Lam Hing Street,
              Kowloon Bay, Kowloon, Hong Kong
            </div>
            <div>Office: (+852) 2111 1417</div>
            <div>Email: info@wwahk.com</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
